import { ValidationErrors, AbstractControl } from '@angular/forms';
import { RootState } from '@next/core-lib/app';
import { Store, select } from '@ngrx/store';
import { of, timer, Observable } from 'rxjs';
import { map, switchMap, withLatestFrom, take } from 'rxjs/operators';

import { isCycleNumberAllowed } from '../store/selectors/cycle.selectors';

export const cycleNumberValidator =
  (store: Store<RootState>) =>
  (input: AbstractControl): Observable<ValidationErrors | null> =>
    timer(1).pipe(
      withLatestFrom(
        store.pipe(
          select(isCycleNumberAllowed),
          map((f) => f(parseInt(<string>input.value, 10))),
        ),
      ),
      switchMap(([_, res]) => (res ? of(null) : of(<ValidationErrors>{ cycleNumberExists: true }))),
      take(1),
    );
